<template>
  <header class="desktop">
    <SearchRailEnchanced />
    <NavigationRail />
  </header>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import NavigationRail from './NavigationRail.common';
import SearchRailEnchanced from './SearchRailEnchanced.common';
</script>
